import { render, staticRenderFns } from "./SalaryCalculator.vue?vue&type=template&id=6bb48b12&scoped=true"
import script from "./SalaryCalculator.vue?vue&type=script&lang=js"
export * from "./SalaryCalculator.vue?vue&type=script&lang=js"
import style0 from "./SalaryCalculator.vue?vue&type=style&index=0&id=6bb48b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb48b12",
  null
  
)

export default component.exports